import { render, staticRenderFns } from "./totalStatus.vue?vue&type=template&id=0d03b730&scoped=true&"
import script from "./totalStatus.vue?vue&type=script&lang=js&"
export * from "./totalStatus.vue?vue&type=script&lang=js&"
import style0 from "./totalStatus.vue?vue&type=style&index=0&id=0d03b730&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d03b730",
  null
  
)

export default component.exports